import React, { Component } from 'react'
import Waypoint from 'react-waypoint'
import axios from 'axios'
import classnames from 'classnames'
import { Link } from 'react-router-dom'
import { throttle } from 'lodash'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import InlineSVG from 'components/InlineSVG'
import Search from './Search'
import Menu from './MainMenu'

import './header.css'

const API_URL = process.env.REACT_APP_API_PATH
const REST_BASE = process.env.REACT_APP_REST_BASE

class Header extends Component {
  constructor (props) {
    super(props)

    this.state = {
      sticky: false,
      showSearch: false,
      slideUp: false,
      search: {
        loaded: true,
        meta: '',
        term: '',
        results: []
      }
    }

    this.scroll = 0

    this.toggleSticky = this.toggleSticky.bind(this)
    this.toggleSearch = this.toggleSearch.bind(this)
    this.onKeydown = this.onKeydown.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.onPageChange = this.onPageChange.bind(this)
    this.onSearchInputChange = this.onSearchInputChange.bind(this)
    this.onSearchSubmit = this.onSearchSubmit.bind(this)
    this.fetchSearchResults = this.fetchSearchResults.bind(this)
    this.closeMenu = this.closeMenu.bind(this)
    this.resetSearch = this.resetSearch.bind(this)
  }

  componentDidMount () {
    document.addEventListener('scroll', throttle(this.onScroll, 50))
  }

  toggleSticky (current, previous) {
    const sticky = current.currentPosition === 'above'
    this.setState({ sticky })
  }

  onSearchInputChange (e) {
    this.setState({
      search: {
        ...this.state.search,
        term: e.target.value
      }
    })
  }

  onSearchSubmit (terms) {
    this.setState({
      search: {
        ...this.state.search,
        loaded: false,
        terms: terms,
        results: [],
        page: 0
      }
    })
    const endpoint = `${API_URL}${REST_BASE}/search/${encodeURIComponent(terms)}`
    console.log(endpoint)
    this.fetchSearchResults(endpoint)
  }

  fetchSearchResults (endpoint) {
    axios.get(endpoint)
      .then((response) => {
        console.log(response)
        this.setState({
          search: {
            ...this.state.search,
            loaded: true,
            response: 200,
            meta: response.data.meta,
            results: response.data.results
          }
        })
      })
      .catch((error) => {
        if (error.response) {
          this.setState({
            search: {
              ...this.state.search,
              loaded: true,
              data: error.response.data,
              meta: false,
              response: error.response.status,
              results: []
            }
          })
          // console.warn('Couldn\'t fetch from', this.props.data.api, 'due to', error, 'node not found')
        } else {
          // console.warn('Couldn\'t fetch from', this.props.data.api, 'due to', error, 'is the API down?')
          this.setState({
            search: {
              ...this.state.search,
              loaded: true,
              data: null,
              meta: false,
              response: 500,
              results: []
            }
          })
        }
      })
  }

  resetSearch () {
    this.setState({
      search: {
        ...this.state.search,
        loaded: true,
        term: '',
        meta: false,
        results: []
      }
    })
  }

  closeMenu () {
    const isDesktop = window.matchMedia('(min-width: 1200px)').matches
    const results = this.state.search.results

    if (!isDesktop && results && results.length) {
      this.resetSearch()
    } else {
      this.toggleSearch()
    }
  }

  toggleSearch () {
    const showSearch = !this.state.showSearch
    this.setState({ showSearch })

    if (showSearch) {
      disableBodyScroll(this.search.wrapper)
      document.addEventListener('keydown', this.onKeydown, false)
    } else {
      enableBodyScroll(this.search.wrapper)
      document.removeEventListener('keydown', this.onKeydown, false)
      this.resetSearch()
    }
  }

  onPageChange () {
    this.toggleSearch()
  }

  // Hide search when ESC is pressed
  onKeydown (ev) {
    if (ev.keyCode === 27) {
      this.toggleSearch()
    }
  }

  onScroll () {
    const scroll = window.pageYOffset
    const slideUp = scroll > this.scroll

    if (this.scroll >= 0) {
      this.setState(state => {
        if (state.slideUp !== slideUp) {
          return {
            ...state,
            slideUp: slideUp
          }
        }
      })
    }

    this.scroll = scroll
  }

  render () {
    let loader = this.props.loader || <InlineSVG icon='logo' />
    return (
      <div className={classnames({
        'header-wrapper': true,
        'header--sticky': this.state.sticky,
        'header--search': this.state.showSearch,
        'header--slide-up': this.state.slideUp,
        'header--light': this.props.theme === 'light'
      })}>
        <Waypoint onPositionChange={this.toggleSticky} bottomOffset='-1px' />
        <header className='header'>
          <div className='container-fluid'>
            <div className='header__inner'>
              <Link
                to='/'
                className='header__logo'>
                {loader}
              </Link>
              <div className='header__menu-wrap'>
                <Menu
                  mainmenu={this.props.menu}
                  toggleSearch={this.toggleSearch}
                />
                <Search
                  {...this.state.search}
                  ref={search => { this.search = search }}
                  submitHandler={this.onSearchSubmit}
                  onInputChange={this.onSearchInputChange}
                  visible={this.state.showSearch}
                  onNav={this.onPageChange}
                  menu={
                    <Menu
                      mainmenu={this.props.menu}
                      toggleSearch={this.toggleSearch}
                      onNav={this.onPageChange}
                    />
                  }
                />
              </div>
              <InlineSVG icon='hamburger' onClick={this.toggleSearch} />
              <InlineSVG icon='close' onClick={this.closeMenu} />
            </div>
          </div>
        </header>
      </div>
    )
  }
}

export default Header



// WEBPACK FOOTER //
// ./src/components/Header/index.js